import { Alert, Button, Modal, ModalBody, ModalFooter, ModalHeader, UncontrolledTooltip } from 'reactstrap';
import api from '../../../api/api';
import apifunctions from '../../../api/functions';
import React, { useEffect, useState } from 'react'

const NotificarLT = ({ id, onSubmit }) => {

  const [show, setShow] = useState(false);
  const [imputacion, setImputacion] = useState(false);
  const [error, setError] = useState(null);
  const [done, setDone] = useState(false);

  const imp_id = id && id();

  useEffect(() => {
    if (imp_id && show) {
      const getAndProcess = (reintento = 0) => {
        const failureCallback = () => {
          if(reintento < 3) getAndProcess(reintento + 1);
          else {
            setImputacion(false);
            setShow(false);
            setDone(false);
            setError(null);
          }
        }
        const successCallback = (data) => {
          if (data.success) {
            setDone(data.imputacion.estado != 'IMP-N');
            setImputacion({
              ...data.imputacion,
              codigo: data.imputacion.cod,
              nroFactura: data.imputacion.nroFactura,
              ottNombre: data.ott_nombre,
              ottEmail: data.ott_email,
              separacion: data.separacion,
            })

          } else {
            setError(data.error);
          }
        }
        apifunctions.get(api.imputaciones.imputaciones.notificarlt, imp_id, null, null, successCallback, failureCallback, failureCallback);
      }
      getAndProcess();

      setImputacion(false);
      setDone(false);
      setError(null);
    }

  }, [show]);

  const enviar = () => {
    const callback = () => {
      setImputacion(false);
      setShow(false);
      setDone(false);
      setError(null);
      onSubmit();
    };
    apifunctions.post(api.imputaciones.imputaciones.notificarlt, imp_id, null, callback, callback, callback);
  }

  const toggle = () => setShow(!show);

  return (
    <React.Fragment>
      <Button
        id="btn-enviar-mail-lt"
        color={"primary"}
        className="btn-sm h-100 rounded"
        onClick={() => setShow(true)}
      ><i className="fa fa-envelope"></i></Button>
      <UncontrolledTooltip target="btn-enviar-mail-lt">
        Enviar mail al Líder Técnico
      </UncontrolledTooltip>
      <Modal className="ui-modal-dialog ui-modal-md modal-primary" toggle={toggle} isOpen={show}>
        <ModalHeader toggle={toggle}>
          Notificar Líder Técnico
        </ModalHeader>
        <ModalBody>
          <div className="ui-form">
            {(error && error.Lider) && <Alert color="danger">{error.Lider}</Alert>}
            {imputacion ? (
              <React.Fragment>
                <section className="ui-section-block">
                  <h5 className="ui-section-label">Datos de la imputación</h5>
                  <div className="ui-detail-list">
                    <div><span>Presupuesto</span><strong>{imputacion.codigo}</strong></div>
                    <div><span>Nro Factura</span><strong>{imputacion.nroFactura}</strong></div>
                    <div><span>OTT</span><strong>{`${imputacion.ottNombre} (${imputacion.ottEmail})`}</strong></div>
                  </div>
                </section>
                <section className="ui-section-block">
                  <h5 className="ui-section-label">Notificación</h5>
                  {done ? (
                    <Alert color="warning" className="mb-0">
                      El líder técnico ya ha sido notificado. ¿Desea volver a enviarle un mail?
                    </Alert>
                  ) : (
                    (imputacion.separaciones && imputacion.separaciones.length > 0) &&
                    <p className="mb-0">
                      Se enviará un mail a <strong>{imputacion.separaciones[0].personal_nombre}</strong> para notificarle que tiene una imputación pendiente.
                    </p>
                  )}
                </section>
              </React.Fragment>
            ) : (
              <section className="ui-section-block">
                <h5 className="ui-section-label">Estado</h5>
                <Alert color="danger" className="mb-0">
                  Debe seleccionar una imputación.
                </Alert>
              </section>
            )}
          </div>
        </ModalBody>
        <ModalFooter>
          <Button
            color="success"
            className="rounded btn-md"
            onClick={enviar}
          >Confirmar</Button>
          {' '}
          <Button
            onClick={() => setShow(false)}
            color="secondary"
            className="rounded btn-md"
          >
            Cancelar
          </Button>
        </ModalFooter>
      </Modal>
    </React.Fragment>
  )
}
export default NotificarLT;



// WEBPACK FOOTER //
// ./src/views/Imputaciones/Imputaciones/NotificarLT.js